var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9022 12.8392C10.7876 12.8277 10.6501 12.8277 10.5241 12.8392C7.79697 12.7475 5.63135 10.5132 5.63135 7.76316C5.63135 4.95587 7.9001 2.67566 10.7188 2.67566C13.5261 2.67566 15.8063 4.95587 15.8063 7.76316C15.7949 10.5132 13.6293 12.7475 10.9022 12.8392Z",
    stroke: "#233F39",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2093 4.96692C21.4322 4.96692 23.2197 6.76588 23.2197 8.97734C23.2197 11.143 21.5009 12.9075 19.3582 12.9878C19.2666 12.9763 19.1634 12.9763 19.0603 12.9878",
    stroke: "#233F39",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17319 17.0669C2.40028 18.9232 2.40028 21.9482 5.17319 23.793C8.32423 25.9013 13.4919 25.9013 16.643 23.793C19.4159 21.9367 19.4159 18.9117 16.643 17.0669C13.5034 14.97 8.33569 14.97 5.17319 17.0669Z",
    stroke: "#233F39",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4207 23.3007C22.2457 23.1288 23.0248 22.7965 23.6665 22.3038C25.454 20.9632 25.454 18.7517 23.6665 17.4111C23.0363 16.9298 22.2686 16.609 21.455 16.4257",
    stroke: "#233F39",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/profiles.379aa350a52c09fdaabd2ada225fc53c.svg";
export { ForwardRef as ReactComponent };